module.exports = __webpack_public_path__ + "waiting-for-octopus.55f3fc473fe540b3c66e778a0e31dfd8.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/resources/images/waiting-for-octopus.svg
// module id = 442
// module chunks = 8